import React from "react";
import { Phone } from "lucide-react";
import { PHONE, PHONE_TEL } from "@/showroomData";
import { SHOWROOM } from "@/constants/testIds";

export const CallBar = () => (
  <a
    href={`tel:${PHONE_TEL}`}
    data-testid={SHOWROOM.callLink}
    className="fixed bottom-4 left-1/2 z-40 flex -translate-x-1/2 items-center gap-2.5 rounded-full border border-white/10 bg-black/50 px-5 py-3 backdrop-blur-xl transition-transform duration-200 hover:-translate-y-0.5 hover:border-cyan-400/40"
    style={{ boxShadow: "0 0 24px rgba(6,182,212,0.18)" }}
  >
    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-cyan-500/20 text-cyan-300">
      <Phone size={16} />
    </span>
    <span className="text-sm text-slate-300">Call us</span>
    <span className="font-display text-base font-semibold tracking-tight text-white">{PHONE}</span>
  </a>
);
